var windowW       = $(window).width();
var windowH       = $(window).innerHeight();
var _isSP         = false;
var _isipad  = false;

// テスト
var _isTest = false;

//preload
import {preload} from "../include/module";
preload();

//toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

//pageTop
import {pageTop} from "../include/module";
pageTop();

//showMovie
import {showMovie} from "../include/module";
showMovie();

$(window).on('load' , function() {

  showItem();
  scrollIndexAnime();

  setTimeout(function(){$('.index-Bg_Item_Orange').addClass("show");},100);
  setTimeout(function(){$('#st-Header').removeClass("hidden");},200);


  $('.sw-Ttl-Lower').children(".txt").textyleF(
    {
      duration :1000, //エフェクト時間(ミリ秒)
      delay : 80, //文字間のエフェクト間隔(ミリ秒)
      easing : 'cubic-bezier(0.16, 1, 0.3, 1)', //エフェクトのイージングパターン
    }
  );

  // changeImg();



});

// ------------------------------------------------------------------------
// changeImg
// ----- BOTH
// ------------------------------------------------------------------------
const changeImg = () => {

  const thumbs = document.querySelectorAll('.thumb');
  // console.log(thumbs);
  thumbs.forEach(function(item,index){
    item.onclick = function(){
      document.getElementById('bigimg').src = this.dataset.image;
      $(".img_Nav li").removeClass("current");
      $(this).parent().addClass("current");
    }
  });

};


// ------------------------------------------------------------------------
// scrollIndexAnime
// ----- BOTH
// ------------------------------------------------------------------------
const scrollIndexAnime = () => {

  const controller = new ScrollMagic.Controller();

  //　スクロールで発火系
  const targets = document.querySelectorAll(".js-scrollAnimation");
  const targetsArray = Array.prototype.slice.call(targets); //Array
  targetsArray.forEach(target => {
    //シーンを作成
    const scene3 = new ScrollMagic.Scene({
        triggerElement: target,
        triggerHook: .85
    })
    .setClassToggle(target, "is-animated")
    .addTo(controller);
  });

  //ロゴ調整
  new ScrollMagic.Scene({
    // triggerElement:'#entry',
    triggerHook: 1,
    offset: '120'
  })
  .setClassToggle("#st-Header", "st-Header-small")
  .addTo(controller);

};

// ------------------------------------------------------------------------
// showItem
// ----- BOTH
// ------------------------------------------------------------------------
const showItem = () => {
  const $body = $('#goods-Box_Body');
  const $bg = $('#goods-Stage');

  $('.js-modal').on('click', function(){

    const dataItem = $(this).data('href');
    itemOpen(dataItem);

  });


  // モーダルを開く
  function itemOpen(target) {

    let html = '';

    //iframe設定
    html += '<iframe src="' + target + '"></iframe>';
    $('#goods-Box_Body').append(html);

    // モーダルが開いたら、bodyにfixedを付与
    // bodyFixedOn();
    $('#goods-Stage').css({'opacity':'0','display':'block'}).stop().animate({'opacity':'1','width':100+'%','height':100+'%','top':0,'left':0},300,'easeOutQuart',function(){

      // fadeIn
      $bg.stop().fadeIn(400);

      $('#goods-Box').addClass('show');

      return false;

    });

  };



  //close
  $('#goods-Box_Close, #goods-Bg').on('click', function(){

    $('#goods-Stage').css({'opacity':'1'}).stop().animate({'opacity':'0'},300,'easeOutQuart',function(){

      $('#goods-Stage').css({'display':'none'});
      $('#goods-Box').removeClass('show');
      $('#goods-Box_Body').children('iframe').remove();

    });
  });
};



// WEBPACK FOOTER //
// ./src/assets/js/goods/script.js